/** Parses a re-rent asset name into vendor, type and unit. Returns null when the name does not match. */
export function rerentNameParts(
    name: string,
): {vendor: string; type: string; unit: string | null} | null {
    const match = /^(.+?) — (.+?)(?:, unit (.+))?$/.exec(name)
    const vendor = match?.[1]
    const type = match?.[2]
    if (vendor == null || type == null) return null

    return {vendor, type, unit: match?.[3] ?? null}
}
